import { createContext } from 'react';
import { DashboardProspectsDIRContextProps } from './DashboardProspectsDIR.types';

export const DashboardProspectsDIRContext = createContext<DashboardProspectsDIRContextProps>(
  {} as DashboardProspectsDIRContextProps
);
